import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_SEARCH_RESULTS, CLEAR_SEARCH_RESULTS } from './constants';

export const setSearchResults = (searchResults) => {
  return createAction({
    type: SET_SEARCH_RESULTS,
    payload: searchResults,
  });
};

export const clearSearchResults = () => {
  return createAction({
    type: CLEAR_SEARCH_RESULTS,
  });
};
